var bookshelf = require("../index-extended");
require("./VotingCategory");

module.exports = bookshelf.model("BuildingOwnerVotingRight", {
  entityName: "BuildingOwnerVotingRight",
  entityTimestampable: true,
  entitySync: true,
  entityUuid: true,

  tableName: "building_owner_voting_right",
  votingCategory() {
    return this.belongsTo("VotingCategory", "voting_category_id");
  },

  format(attrs) {
    delete attrs["$id"];
    delete attrs["votingCategory"];
    delete attrs["buildingOwnerBuildingLot"];

    return attrs;
  },
});
